import React, { useState } from "react";
import Input from "@mostrans/web-components/components/base/Input";
import Button from "@mostrans/web-components/components/base/Button";
import "./Mostest.css";
import { swalAlert } from "../../../../../shared/helpers";
import ResultSimulation from "./ResultSimulation";
import { Divider } from "@mui/material";

function SimulationTest(prop) {
  const { id, handleStart } = prop;
  const key = ["A", "B", "C", "D", "E", "F"];
  const number = [1, 2, 3];
  const nquestion = [3, 2, 3, 3];
  const [idx, setIdx] = useState(0);
  const [values, setValues] = useState([]);
  const [finished, setFinished] = useState(false);

  const KeyImgs = key.slice(0, +id === 2 || +id === 4 ? 5 : 6).map(function (name, i) {
    return (
      <li key={i} className="box__key">
        <label style={{ cursor: "pointer", textAlign: "center" }}>
          <h5>{name}</h5>
          <Input
            type="radio"
            style={{
              position: "absolute",
              opacity: 0,
              width: 0,
              height: 0,
            }}
            checked={+id === 2 ? values[idx]?.split("").includes(name) : values[idx] === name}
            onChange={() => {
              const value = [...values];
              if (+id === 2) {
                if (idx >= 1) {
                  setValues((old) => {
                    const prev = old[idx]?.at(0) || "";
                    old[idx] = name + prev;
                    if (old[idx]?.length >= 3) {
                      old[idx] = old[idx].slice(0, -1);
                    }

                    return [...old];
                  });

                  return;
                }
                setValues((old) => [name + old]);

                if (values[idx]?.length >= 2) {
                  setValues(values[idx].slice(0, -1));
                  setValues((old) => [name + old]);
                }
                return;
              }
              value[idx] = name;
              setValues(value);
            }}
          />
          <img
            src={require("../../../../../components/Layout/assets/CFIT/Section " +
              id +
              "/CONTOH " +
              `${number[idx]} ` +
              name +
              ".PNG")}
            alt={name}
            className="img-responsive"
            key={i}
          />
        </label>
      </li>
    );
  });

  const btnNext = () => {
    setIdx(idx + 1);
  };

  const btnFinish = () => {
    if (values.includes(undefined)) {
      swalAlert({
        text: "Terdapat jawaban yang kosong, silahkan ulangi kembali!",
      });
    } else {
      setIdx(0);
      setFinished(true);
    }
  };

  const btnBox = (item) => {
    setIdx(item - 1);
  };

  const props = {
    key: key,
    nquestion: nquestion,
    number: number,
    values: values,
    handleStart: handleStart,
    ids: id,
  };

  const disableButton = () => {
    if (+id === 2 && values[idx]?.length !== 2) {
      return true;
    }
    return !values[idx];
  };

  return finished ? (
    <ResultSimulation props={props} />
  ) : (
    <div className="container-fluid shadow-soft-s3 p-2">
      <div className="d-flex header">
        <h4>Simulasi Section {id}</h4>
      </div>
      <Divider sx={{ marginY: "20px" }} />
      <div className="d-grid content">
        {(() => {
          if (+id !== 2) {
            return (
              <div className="question__list m-auto py-2">
                <img
                  src={require("../../../../../components/Layout/assets/CFIT/Section " +
                    id +
                    "/Contoh-soal-" +
                    number[idx] +
                    ".png")}
                  alt={"Soal " + id}
                />
              </div>
            );
          }
        })()}

        <div className="question__key m-auto py-2">
          <ul className="d-flex">{KeyImgs}</ul>
        </div>
        <div className="btn__next text-center py-2">
          {(() => {
            if (idx + 1 === nquestion[id - 1]) {
              return (
                <Button
                  disabled={disableButton()}
                  color="primary"
                  variant="contained"
                  onClick={btnFinish}>
                  Selesai
                </Button>
              );
            } else {
              return (
                <Button
                  disabled={disableButton()}
                  color="primary"
                  variant="contained"
                  onClick={btnNext}>
                  Selanjutnya
                </Button>
              );
            }
          })()}
        </div>
      </div>
      <div className="footer d-grid m-1 text-center listbox">
        <ul>
          {Array.apply(null, { length: nquestion[id - 1] }).map((_, id) => (
            <li
              key={id}
              style={styles.spanBox}
              className={`text-primary-main-hover bg-neutral-n2-hover ${
                idx === id ? "active" : values[id] ? "filled" : ""
              }`}
              onClick={() => {
                btnBox(id + 1);
              }}>
              <span>{id + 1}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

const styles = {
  spanBox: {
    width: "35px",
    margin: "5px",
    border: "2px solid #e1e1e1",
    cursor: "pointer",
    display: "inline-block",
  },
};

export default SimulationTest;
